import React, { useState } from "react";
import { useUsers } from "../../../hooks/useUsers";
import { User } from "../../../types/User";
import UserList from "./UserList";
import { toast } from "react-toastify";
import InvitationForm from "../inviation/InvitationForm";
 import {
  PlusOutlined,
  ExclamationCircleOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import api from "../../../services/axiosInstance";
import { InvitationData } from "../inviation/types/types";

import { useQueryClient } from "@tanstack/react-query";
interface UserManagementProps {
  onNavigateHome?: () => void;
}
const UserManagement: React.FC<UserManagementProps> = ({ onNavigateHome }) => {
  const {
    users, allUsers, loading, error,
    searchTerm, sortField, sortDirection,
    currentPage, totalPages, totalUsers, itemsPerPage,
    setSearchTerm, setCurrentPage, handleSort,
    deleteUser, updateUser, clearError, clearFilters,
  } = useUsers();
const queryClient = useQueryClient();

   const [showForm, setShowForm]                   = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState<number | null>(null);
  const [editingUser, setEditingUser]             = useState<User | null>(null);
  const [editingLoading, setEditingLoading]       = useState(false);
const [invitationLoading, setInvitationLoading] = useState(false);
const handleSendInvitation = async (data: InvitationData) => {
  setInvitationLoading(true);
  try {
    await api.post("/api/users/invite", data);

     await queryClient.invalidateQueries({ queryKey: ["users"] });

    toast.success("Utilisateur créé avec succès");
    setShowForm(false);
  } catch (err: any) {
    toast.error(err?.response?.data?.error || "Erreur serveur");
  } finally {
    setInvitationLoading(false);
  }
};
  const handleEditUser   = (u: User) => setEditingUser(u);

  const handleUpdateUser = async (updated: { id: number; nom: string }) => {
    setEditingLoading(true);
    try {
      const existing = allUsers.find(x => x.id === updated.id);
      const payload  = existing
        ? { ...existing, nom: updated.nom }
        : { id: updated.id, nom: updated.nom, email: '', isVerified: false, createdAt: new Date().toISOString() };
      await updateUser(payload as unknown as User);
      setEditingUser(null);
    } catch (err) {
     } finally {
      setEditingLoading(false);
    }
  };

  const confirmDelete = async () => {
    if (!showDeleteConfirm) return;
    try {
      await deleteUser(showDeleteConfirm);
      setShowDeleteConfirm(null);
    } catch {}
  };

  const getUserToDelete = () => allUsers.find(u => u.id === showDeleteConfirm);

  return (
    <div className="px-6 lg:px-10 py-8 max-w-full mx-auto">
      <div className="flex flex-wrap items-center justify-between gap-4 mb-6">

        <button
          onClick={() => setShowForm(true)}
          disabled={loading}
          className="flex items-center gap-2 px-5 py-1.5 rounded-xl
                     text-sm font-semibold text-white border-none cursor-pointer
                     bg-blue-700 hover:bg-blue-700
                     shadow-md shadow-blue-200
                     hover:-translate-y-0.5 transition-all duration-200
                     disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
        >
          <PlusOutlined />
          Ajouter Utilisateur
        </button>
      </div>

      {error && (
        <div className="flex items-center gap-3 mb-6
                        bg-rose-50 border border-rose-200 rounded-xl px-4 py-3
                        text-sm text-rose-700">
          <ExclamationCircleOutlined className="text-rose-500 text-base flex-shrink-0" />
          <span className="flex-1">{error}</span>
          <button
            onClick={clearError}
            className="w-6 h-6 flex items-center justify-center rounded-lg
                       bg-rose-100 hover:bg-rose-200 text-rose-500
                       border-none cursor-pointer transition-all duration-200
                       hover:rotate-90"
          >
            <CloseOutlined style={{ fontSize: 11 }} />
          </button>
        </div>
      )}

      <UserList
        users={users}
        onEdit={handleEditUser}
        onDelete={(id) => setShowDeleteConfirm(Number(id))}
        loading={loading}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        sortField={sortField}
        sortDirection={sortDirection}
        handleSort={handleSort}
        currentPage={currentPage}
        totalPages={totalPages}
        totalUsers={totalUsers}
        itemsPerPage={itemsPerPage}
        setCurrentPage={setCurrentPage}
        clearFilters={clearFilters}
      />
{showForm && (
  <InvitationForm
    onSubmit={handleSendInvitation}
    onCancel={() => setShowForm(false)}
    isLoading={invitationLoading}
  />
)}

      {editingUser && (
        <div className="fixed inset-0 z-[2000] flex items-center justify-center p-5
                        bg-gradient-to-br from-blue-500/15 to-pink-400/10
                        backdrop-blur-md"
             style={{ animation: "overlayIn 0.25s ease" }}>
          <div className="bg-white backdrop-blur-xl rounded-2xl w-full max-w-lg
                          border border-white/70 overflow-hidden
                          shadow-[0_24px_48px_-12px_rgba(99,102,241,0.2)]"
               style={{ animation: "modalIn 0.3s cubic-bezier(0.34,1.56,0.64,1)" }}>

            <div className="flex justify-between items-center px-6 py-5
                            border-b border-blue-100 relative">
              <div className="absolute top-0 left-0 right-0 h-[3px]
                              bg-gradient-to-r from-blue-700 via-orange-500 to-orange-400
                              rounded-t-2xl" />
              <h2 className="text-lg font-bold text-blue-950 m-0 tracking-tight">
                Modifier l'utilisateur
              </h2>
              <button
                onClick={() => setEditingUser(null)}
                className="w-9 h-9 flex items-center justify-center rounded-xl
                           bg-blue-50 border-none text-blue-500 cursor-pointer
                           hover:bg-blue-100 hover:rotate-90 transition-all duration-200"
              >
                <CloseOutlined style={{ fontSize: 13 }} />
              </button>
            </div>

            <form
              onSubmit={async (e) => {
                e.preventDefault();
                const form = e.target as HTMLFormElement;
                const nom  = (form.elements.namedItem('nom') as HTMLInputElement).value;
                await handleUpdateUser({ id: editingUser.id, nom });
              }}
              className="px-6 py-5"
            >
              <div className="grid grid-cols-2 gap-4 mb-4">

                <div className="flex flex-col gap-1.5">
                  <label htmlFor="nom"
                         className="text-xs font-semibold uppercase tracking-wide text-blue-700">
                    Nom *
                  </label>
                  <input
                    id="nom"
                    name="nom"
                    type="text"
                    defaultValue={editingUser.nom}
                    placeholder="Nom de l'utilisateur"
                    className="px-3 py-2.5 rounded-xl text-sm text-blue-900
                               border border-blue-200 bg-white/85
                               placeholder-blue-300
                               focus:outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-100
                               hover:border-blue-400 transition-all duration-200"
                  />
                </div>

                <div className="flex flex-col gap-1.5">
                  <label className="text-xs font-semibold uppercase tracking-wide text-blue-700">
                    Email
                  </label>
                  <input
                    type="email"
                    defaultValue={editingUser.email}
                    disabled
                    className="px-3 py-2.5 rounded-xl text-sm text-slate-400
                               border border-slate-100 bg-slate-50
                               cursor-not-allowed"
                  />
                </div>
              </div>

              <div className="flex justify-end gap-3 pt-4
                              border-t border-blue-50">
                <button
                  type="button"
                  onClick={() => setEditingUser(null)}
                  disabled={editingLoading}
                  className="px-5 py-2.5 rounded-xl text-xs font-semibold
                             bg-blue-50 text-blue-700
                             border border-blue-200
                             hover:bg-blue-100 hover:border-blue-300
                             hover:-translate-y-0.5 transition-all duration-200
                             disabled:opacity-45 disabled:cursor-not-allowed"
                >
                  Annuler
                </button>
                <button
                  type="submit"
                  disabled={editingLoading}
                  className="px-5 py-2.5 rounded-xl text-xs font-semibold text-white
                             bg-gradient-to-r from-blue-500 to-blue-400
                             shadow-md shadow-blue-200
                             hover:brightness-105 hover:-translate-y-0.5
                             transition-all duration-200
                             disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
                >
                  {editingLoading ? (
                    <span className="flex items-center gap-2">
                      <span className="w-3 h-3 rounded-full border-2 border-white/30
                                       border-t-white animate-spin" />
                      Sauvegarde...
                    </span>
                  ) : "Sauvegarder"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showDeleteConfirm !== null && (
        <div className="fixed inset-0 z-[2000] flex items-center justify-center p-5
                        bg-gradient-to-br from-rose-500/12 to-blue-500/8
                        backdrop-blur-md"
             style={{ animation: "overlayIn 0.25s ease" }}>
          <div className="bg-white backdrop-blur-xl rounded-2xl w-full max-w-sm
                          border border-white/70 overflow-hidden
                          shadow-[0_24px_48px_-12px_rgba(244,63,94,0.18)]"
               style={{ animation: "modalIn 0.3s cubic-bezier(0.34,1.56,0.64,1)" }}>

            <div className="px-6 pt-6 pb-0 relative">
              <div className="absolute top-0 left-0 right-0 h-[3px]
                              bg-gradient-to-r from-rose-500 to-orange-400
                              rounded-t-2xl" />
              <h3 className="flex items-center gap-2.5 text-base font-bold text-blue-950 m-0">
                <span className="w-7 h-7 flex items-center justify-center rounded-lg
                                 bg-rose-50 text-rose-500 text-xs">
                 
                </span>
                Confirmer la suppression
              </h3>
            </div>

            <div className="px-6 py-5">
              <p className="text-sm text-gray-600 leading-relaxed mb-3">
                Êtes-vous sûr de vouloir supprimer l'utilisateur{" "}
                <strong className="text-blue-950">{getUserToDelete()?.nom}</strong> ?
              </p>
              <p className="text-xs font-medium text-rose-500
                            bg-rose-50 border border-rose-100
                            rounded-lg px-3 py-2">
               </p>
            </div>

            <div className="flex justify-end gap-3 px-6 pb-5
                            border-t border-rose-50 pt-4">
              <button
                onClick={() => setShowDeleteConfirm(null)}
                disabled={loading}
                className="px-5 py-2.5 rounded-xl text-xs font-semibold
                           bg-blue-50 text-blue-700 border border-blue-200
                           hover:bg-blue-100 hover:-translate-y-0.5
                           transition-all duration-200
                           disabled:opacity-45 disabled:cursor-not-allowed"
              >
                Annuler
              </button>
              <button
                onClick={confirmDelete}
                disabled={loading}
                className="px-5 py-2.5 rounded-xl text-xs font-semibold text-white
                           bg-gradient-to-r from-rose-500 to-rose-400
                           shadow-md shadow-rose-200
                           hover:brightness-105 hover:-translate-y-0.5
                           transition-all duration-200
                           disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
              >
                {loading ? (
                  <span className="flex items-center gap-2">
                    <span className="w-3 h-3 rounded-full border-2 border-white/30
                                     border-t-white animate-spin" />
                    Suppression...
                  </span>
                ) : "Supprimer"}
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};
export default UserManagement;